import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=20b4bd45&scoped=true"
import script from "./table-header.vue?vue&type=script&lang=js"
export * from "./table-header.vue?vue&type=script&lang=js"
import style0 from "./table-header.vue?vue&type=style&index=0&id=20b4bd45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4bd45",
  null
  
)

export default component.exports